import React from 'react';
import { ComponentProps } from './Btn.types';
import StyledButton from './Btn.styled';

const Button: React.FC<ComponentProps> = ({ small, appearance, mode, borderVariant = 'rounded', ...props }) => {
  const borderVariantMap = new Map([
    ['rounded', 25],
    ['rectangle', 1],
  ]);

  return (
    <StyledButton
      {...props}
      px={5}
      py={small ? 2 : 4}
      fontSize={4}
      mode={mode}
      borderRadius={borderVariantMap.get(borderVariant)}
    />
  );
};

export default Button;
